import PropTypes from 'prop-types';
import React from 'react';

import { bibShape } from '@bibliocommons/bc-prop-types';
import FormatIndicator from '@bibliocommons/format-indicator';
import { bindAll } from '@bibliocommons/utils-react';

import AvailabilityBibBlock from 'app/components/shared/AvailabilityBibBlock';
import BibBrief from 'app/components/shared/BibBrief';

import '../styles/BibItemInfo.scss';

export class BibItemInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  focusOnTitle() {
    if (this._bibBrief) {
      this._bibBrief.focusOnTitle();
    }
  }

  renderPubYear() {
    const { bib } = this.props;
    const briefInfo = bib.get('briefInfo');
    if (briefInfo.get('publicationDate')) {
      return (
        <span className="pub-year">
          {briefInfo.get('format') ? ' - ' : ''}
          {briefInfo.get('publicationDate')}
        </span>
      );
    }

    return null;
  }

  renderAvailability() {
    const { availabilityDetailActions, bib } = this.props;

    const availability = bib.get('availability');

    if (availability && this.props.showAvailability) {
      return (
        <AvailabilityBibBlock
          bib={bib}
          fetchDigitalAvailability={availabilityDetailActions.getDigitalAvailability}
          hasAvailabilityStatus
          hasFetchDigitalAvailabilityButton
          hasHoldCounts={false}
          hasPhysicalAvailabilityLink={false}
          openAvailabilityOverlay={() => null}
          trackViewAvailabilityClick={() => null}
          trackViewDigitalResourceClick={() => null}
        />
      );
    }

    return null;
  }

  render() {
    const { bib } = this.props;
    const classes = this.props.compact ? 'compact' : '';
    const briefInfo = bib.get('briefInfo');

    return (
      <div className={`cp-catalogue-results-bib-item-info ${classes}`} data-test-item-bib-id={briefInfo.get('id')}>
        <BibBrief
          ref={el => (this._bibBrief = el)}
          bib={briefInfo}
          renderTitleAsLink={false}
          renderAuthorsAsLink={false}
          titleTag="h3"
        >
          <div className="format-and-year">
            <FormatIndicator format={briefInfo.get('format').toUpperCase()} />
            {this.renderPubYear()}
          </div>
        </BibBrief>

        {this.renderAvailability()}
      </div>
    );
  }
}

BibItemInfo.propTypes = {
  bib: bibShape.isRequired,
  showAvailability: PropTypes.bool,
  compact: PropTypes.bool,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default BibItemInfo;
